import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpHeaders, HttpEventType, HttpRequest, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { User } from '../User';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { AlertService } from '../alert.service';
import { ApiService } from '../api.service';
import { useAnimation } from '@angular/animations';
export interface mStatus {
  value: string;
  viewValue: string;
}
export interface occupation {
  value: string;
  viewValue: string;
}
class custProfObj {
  dob: string = "";
  mstatus: string = "";
  living: string = "";
  //occupation:string = "";
  gender:string ="";
  cName: string = "";
  income:string="";
  alternateNo:string="";
  pAddr: string = "";
  comment: string = "";
  constructor(values: Object = {}) {
    //Constructor initialization
    Object.assign(this, values);
  }
}
@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit {
  @ViewChild('picker') picker;
  open() {
    this.picker.open();
  }
  debugData: Boolean = true; // to show and hide the console log messages
  dataUpdatemsg: string = "";
  selectedGender: string;
  selectedOccupation: string;
  private user: User = new User();
  private mstatus: string[];
  private occupation: string[];
  private gender: string[];
  private custFormData: custProfObj; // to store the values of customer form
  public profPictureProgress = 0;
  public profPicture ="";
  selectedFile: File;
  constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService, private apiService: ApiService,
    private httpClient: HttpClient, private alertService: AlertService) {
    this.user = new User();
    this.initCustData();
    //this.custFormData = new custProfObj();
    if (this.debugData == true) {
      console.log("Constructor init");
      console.log(this.custFormData);
    }
  }

  initCustData() {
    if (this.apiService.checkUserLoggedIn() == true) {
      let urrr = this.apiService.cutomerDetails + this.apiService.getFromLocalData('custDD');
      this.httpClient.get(urrr)
        .subscribe(
          data => this.intilizeComponent(data),
          error => this.showError(error)
        );
    } else {
      console.log("User Not Logged In. Please login!")
    }
  }

  intilizeComponent(data) {
    console.log("Profile Data");
    console.log(data);
    this.user = data;
    console.log(this.user);
    console.log(JSON.parse(this.user.otherDetails));
    this.user.otherDetails=JSON.parse(this.user.otherDetails);
    console.log(this.user.otherDetails);
   
  }
  showError(msg) {
    console.log("Error Found in server");
  }

  ngOnInit() {
    this.mstatus = ['Married', 'Single'];
    this.gender =['Male','Female'];
    this.occupation = ['Student', 'Employee', 'Self Employed'];
    this.custFormData = new custProfObj({
      dob: "", mstatus: "",gender:"", living: "", occupation: "", cName: "",income:"",alternateNo:"",pAddr: "", comment: ""
    });
  }

  private submitted: object = {};
  onSubmit(f) {
    this.submitted = f.value;
  }
  public dateToSearch = "";
  getDate(birthDate) {

    if ((typeof birthDate === 'string') && (birthDate.indexOf('/') > -1)) {
      const str = birthDate.split('/');
      const year = Number(str[2]);
      const date = Number(str[1]);
      const month = Number(str[0]);
      this.dateToSearch = year + "-" + month + "-" + date;
    }
  }

  public onFormSubmit({ value, valid }: { value: custProfObj, valid: boolean }) {
    this.custFormData = value;
    this.custFormData.dob = this.dateToSearch;
    console.log(this.custFormData);
    console.log("valid: " + valid);
    let aa = "hello";
    const myObjStr = JSON.stringify(this.custFormData);
    //console.log(JSON.stringify(this.custFormData))
    let custid_url = this.apiService.cutomerDetails + this.user.id;
    let postCustData = { 'otherDetails': myObjStr };
    console.log(postCustData);
    this.httpClient.post(custid_url, postCustData)
      .subscribe(
        (dataProfile: any) => {
          if (this.debugData) {
            console.log("customer form function api data");
            console.log(dataProfile);
          }
          this.initCustData();
          console.log(this.user.otherDetails);
          this.dataUpdatemsg = "Data updated Successfully";
          this.user = dataProfile.obj;
          console.log(this.user);
        },
        (err) => {
          this.dataUpdatemsg = "Some error occured. Please try again";
        });
  }

  checkCustData(): boolean  {
    if (!this.user.otherDetails)
    { return true }
    else { return false }
  }
  buttonDisabled: boolean = true;
  dataUpdatemsg1:string ="";
  saveData(dobUser,statusUser,livingUser,occupUser,cnameUser,incomeUser,altNoUser,paddUser,commentUser)
  {
   let editData = {'dob':dobUser,'mstatus':statusUser,'living':livingUser,'occupation':occupUser,'cName':cnameUser,'income':incomeUser,'alternateNo':altNoUser,'pAddr':paddUser,'comment':commentUser};
   console.log(editData);
   const myObjStr1 = JSON.stringify(editData);
  //  let dataPost =dobUser +"," +statusUser+"," +livingUser+"," +occupUser+"," +cnameUser+"," +paddUser+"," +commentUser;
   let custid_url1 = this.apiService.cutomerDetails + this.user.id;
   let postData ={'otherDetails':myObjStr1};
    console.log(postData);
    this.httpClient.post(custid_url1, postData)
      .subscribe(
        (datacustProfile: any) => {
          if (this.debugData) {
            console.log("data");
            console.log(datacustProfile);
          }
          this.initCustData();
          console.log(this.user.otherDetails);
          this.dataUpdatemsg1 = "Data updated Successfully";
          this.user = datacustProfile.obj;
          console.log(this.user);
        },
        (err) => {
          this.dataUpdatemsg1 = "Some error occured. Please try again";
        });
  }
  key:string ='profilePicture';
   //_________________________________________________________________________________________________
  // start of document upload//
  onSelectFile(event, idType) { // called each time file input changes
  
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]); // read file as data url
    this.selectedFile = event.target.files[0];
    reader.onload = (event) => { // called once readAsDataURL is completed
      //console.log("data selected loaded");
      this.onUpload(idType);
    }
  }
 
  onUpload(idTypeA) {
    let urlUploads = this.apiService.postsURL + 'uploadCustomerDoc?id=' + this.user.id + '&key=' + idTypeA;
    if (idTypeA == 'profilePicture'){
      urlUploads += '&old=' + this.profPicture;
    }
    const uploadData = new FormData();
    uploadData.append('image', this.selectedFile, this.selectedFile.name);
    this.httpClient.post(urlUploads, uploadData, {
      reportProgress: true,
      observe: 'events'
    }).subscribe(
      event => this.handleUploadProgress(event, idTypeA)
    );
  }


  handleUploadProgress(event, idTypeA) {
    if (event.type === HttpEventType.DownloadProgress) {
      //this.uploadingProgressing = true
      //this.uploadProgress = Math.round(100 * event.loaded / event.total)
    }

    if (event.type === HttpEventType.UploadProgress) {
      if (idTypeA == 'profilePicture') {
        this.profPictureProgress = Math.round(100 * event.loaded / event.total)
      } 
    }

    if (event.type === HttpEventType.Response) {
      if (event.body.status == true) {
        this.intilizeComponent(event.body.customer)
        console.log("uploaded suscessfully");
      } else if (event.body.status == false) {
        console.log("uploaded failed! Try Again.");
      }
      //console.log(event.body)
    }
  }
  // end of doucment upload
  //_____.._________________________________________________________________________________________

}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/my-profile/my-profile.component.ts